export default __webpack_public_path__ + "static/media/latte.3f984cd9.png";